import { login } from './auth.backend';
import { put } from 'redux-saga/effects';
import {
    fetchUserPermissionsFail,
    fetchUserPermissionsSuccess,
    loginFail,
    loginSuccess
} from './actions';
import {
    makeErrorPayload,
    makeLoginErrorPayload
} from '../../../shared/helpers/payload.helper';
import { setErrorToast } from '../../../shared/toast/redux/actions';
import { getUserById } from '../../../main/main-content/team/user/redux/user.backend';
import {
    extractPermissionsForUser,
    unscopedPermissions
} from '../../../shared/models/permissions';
import * as _ from 'lodash';
import {
    clearLocalCredentials,
    isLocalLogin,
    noAccessTokenMessage,
    setLocalCredentials
} from '../local-auth';

function* failLogin(formattedError) {
    yield put(loginFail(formattedError));
    yield put(setErrorToast(formattedError));
}

export function* loginSaga(action) {
    const { username, password } = action.payload;
    try {
        const response = yield login(username, password);
        const data = response.data || {};

        if (isLocalLogin(data)) {
            // Set before the login succeeds, so that the first request after it (the user's permissions) carries it.
            setLocalCredentials(username, password);
        } else if (!data.accessToken) {
            // A backend that checks passwords itself. Going on would fail to decode the empty token, with no message to show.
            yield* failLogin({ message: noAccessTokenMessage });
            return;
        }
        yield put(loginSuccess(response));
    } catch (error) {
        clearLocalCredentials();
        yield* failLogin(makeLoginErrorPayload(error));
    }
}

// todo: Remove once permissions are added to the token.
export function* fetchUserPermissionsSaga(action) {
    const { userId } = action.payload;
    try {
        const response = yield getUserById(userId);
        yield put(
            fetchUserPermissionsSuccess({
                permissions: [
                    ...(response.data.permissions || []),
                    // `permissions` only lists a team's permissions for the
                    // jurisdictions the team has. Unscoped ones apply without
                    // any, so take those from the teams themselves.
                    ...extractPermissionsForUser(
                        response.data
                    ).filter(permission =>
                        _.includes(unscopedPermissions, permission)
                    )
                ]
            })
        );
    } catch (error) {
        const formattedError = makeErrorPayload(error);

        yield put(fetchUserPermissionsFail({ error: formattedError }));
        yield put(setErrorToast(formattedError));
    }
}
